import { ChipIcon } from '@heroicons/react/solid';
import PropTypes from 'prop-types';
import React from 'react';
import { arraySorter, checkEmpty } from '@/utils/commonFunctions';
import RenderSkills from './RenderSkills';
import { SkillsWrapper, StyledContainer } from './styles';
import colors from '@/styles/colors';

export default function Skills({ skills }) {
  const modifiedSkills = skills.reduce((acc, curr) => {
    const { type } = curr;
    if (checkEmpty(acc[type])) {
      acc[type] = [curr];
    } else {
      acc[type] = arraySorter([...acc[type], curr], 'order', true);
    }
    return acc;
  }, {});

  return (
    <StyledContainer id="skills" className="px-4 py-10 mx-auto">
      <div className="flex items-center mb-4">
        <ChipIcon className="w-10 inline-block mr-4" color={colors.lighter} />
        <h1 className="sm:text-4xl text-3xl font-medium title-font text-white">Skills &amp; Technologies</h1>
      </div>
      <SkillsWrapper>
        {Object.keys(modifiedSkills).map((type) => (
          <RenderSkills skills={modifiedSkills[type]} key={type} title={type} />
        ))}
      </SkillsWrapper>
    </StyledContainer>
  );
}

Skills.propTypes = {
  skills: PropTypes.oneOfType([PropTypes.array]).isRequired,
};
